import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import Category from 'marketing/components/categories';
import { fetchCategoriesIfNeeded, excludeDeprecated } from 'common/ducks/categories';
import { bindActionCreators } from 'redux';

const FORM_NAME = 'BROWSE_CATEGORY_FORM';

export function mapStateToProps(state) {
  const categories = excludeDeprecated(state.categories.data).filter(c => !c.is_one_to_one);
  const selector = formValueSelector(FORM_NAME);
  const value = selector(state, 'category');

  const matchedCategories = categories.reduce((mem, category) => {
    const matchedSubs = category.sub_categories.reduce((matched, subcat) => (
      (value && subcat.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) || (!value)
        ? [...matched, subcat]
        : matched
    ), []);

    return matchedSubs.length
      ? [...mem, { ...category, sub_categories: matchedSubs }]
      : mem;
  }, []);

  return {
    formName: FORM_NAME,
    matchedCategories: matchedCategories || [],
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCategoriesIfNeeded
  }, dispatch);
}

const CategoryForm = reduxForm({ form: FORM_NAME })(Category);


CategoryForm.need = [fetchCategoriesIfNeeded];

export default connect(mapStateToProps, mapDispatchToProps)(CategoryForm);



// WEBPACK FOOTER //
// ./marketing/containers/categories.js